import axios from './axios.js';

function get (url, params = {}, config = {}) {
  return axios.get(url, {
    params,
    isSimple: true,
    ...config,

  });
}
function post (url, data = {}, config = {}) {
  return axios.post(url, data, { isSimple: true, ...config });
}


function getArticleDetail (id) {
  return get('/investment/cms/detail?id=' + id,);
}


export default {
  get,
  post,
  getArticleDetail,
}